import { ElementType } from 'react';
import { Box, styled, Typography, useTheme } from '@mui/material';
import { FOOTER_HEIGHT } from '@/constants/layout.ts';

const FooterArea = styled(Box)(({ theme }) => ({
	height: FOOTER_HEIGHT,
	width: '100%',
	position: 'fixed',
	bottom: 0,
	left: 0,
	zIndex: theme.zIndex.drawer + 1,
	backgroundColor: theme.palette.mode === 'light'
		? theme.palette.grey[200]
		: theme.palette.grey[800],
	borderTop: `1px solid ${theme.palette.divider}`,
}));

const Footer: ElementType = () => {
	return (
		<FooterArea>
			<Typography 
				variant="body2" 
				color="text.secondary" 
				align="center">
				© {new Date().getFullYear()} MyHelpers. All rights reserved.
			</Typography>
		</FooterArea>
	)
}

export default Footer;
